<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00058.installation.pompe.titre' | translate"
      [description]="
        brandOverride('P00058.installation.pompe.description' | translate)
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00058.installation.pompe.speedUnit' | translate"
      [titleListe]="'P00058.installation.pompe.unit' | translate"
      [information]="getSpeedUnitInformation"
      [value]="actionStack!.getValue('pvPUniteConsignePompe')"
      [liste]="P00058SpeedUnitEnum"
      [description]="
        'P00058.installation.pompe.speedUnitDescription' | translate
      "
      (onPress)="onSpeedUnitChange($event)"
    >
    </app-label-configuration>

    <app-label-configuration
      [title]="'P00058.installation.pompe.speeeds' | translate"
      [titleListe]="'P00058.installation.pompe.speed1' | translate"
      [value]="actionStack!.getValue('pvPVitesseV1')"
      [liste]="getSpeedEnum(35, 100)"
      [description]="'P00058.installation.pompe.speed1.description' | translate"
      (onPress)="onSpeed1Change($event)"
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="'P00058.installation.pompe.speed2' | translate"
      [value]="actionStack!.getValue('pvPVitesseV2')"
      [liste]="getSpeedEnum(35, 100)"
      [description]="'P00058.installation.pompe.speed2.description' | translate"
      (onPress)="onSpeed2Change($event)"
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="'P00058.installation.pompe.speedMAX' | translate"
      [value]="actionStack!.getValue('pvPVitesseV3')"
      [liste]="getSpeedEnum(35, 100)"
      [description]="
        'P00058.installation.pompe.speedMAX.description' | translate
      "
      (onPress)="onSpeed3Change($event)"
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="'P00058.installation.pompe.speedDeco' | translate"
      [value]="actionStack!.getValue('pvIConsignePompeDoconnexion')"
      [liste]="getSpeedEnum(35, 100)"
      [description]="
        'P00058.installation.pompe.speedDeco.description' | translate
      "
      (onPress)="onSpeedDecoChange($event)"
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
